/** If the content displayed on the page is equal to the initial display,
 * direct the canonical to the path of the initial display. */
const createCanonicalUrlForVerticalPage = (
  proListPageFromUrl: string | Array<string> | undefined,
  caseStudyPageFromUrl: string | Array<string> | undefined,
  currentProListPage: number,
  currentCaseStudiesPage: number,
  currentUrl: string
) => {
  // eslint-disable-next-line prefer-destructuring
  const baseCanonicalUrl = currentUrl.replace('/en/', '/').split('?')[0];
  if (proListPageFromUrl === '1' && caseStudyPageFromUrl === '1') {
    return {
      canonicalUrl: baseCanonicalUrl,
      shouldIncludeUrlParams: false,
    };
  }

  if (
    (proListPageFromUrl === '1' && caseStudyPageFromUrl === undefined) ||
    (proListPageFromUrl === undefined && caseStudyPageFromUrl === '1')
  ) {
    return {
      canonicalUrl: baseCanonicalUrl,
      shouldIncludeUrlParams: false,
    };
  }

  if (proListPageFromUrl === '1') {
    return {
      canonicalUrl: `${baseCanonicalUrl}?caseStudyPage=${currentCaseStudiesPage}`,
      shouldIncludeUrlParams: true,
    };
  }
  if (caseStudyPageFromUrl === '1') {
    return {
      canonicalUrl: `${baseCanonicalUrl}?page=${currentProListPage}`,
      shouldIncludeUrlParams: true,
    };
  }

  if (currentUrl.endsWith('?')) {
    return {
      canonicalUrl: baseCanonicalUrl,
      shouldIncludeUrlParams: false,
    };
  }

  return {
    canonicalUrl: '',
    shouldIncludeUrlParams: false,
  };
};

export { createCanonicalUrlForVerticalPage };
